export default "__VITE_ASSET__eBB5uVE_t2Bb1etqpZE3Ig__ 480w, __VITE_ASSET__cLLFq7OX38PQjR0WE41fig__ 745w";